// MonthlyOrderChart.jsx
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts';
import dayjs from 'dayjs';

const MonthlyOrderChart = ({ orders }) => {
    const monthlyCounts = {};

    orders.forEach(order => {
        const month = dayjs(order.pickupdate).format('YYYY-MM'); // e.g. 2025-04
        monthlyCounts[month] = (monthlyCounts[month] || 0) + 1;
    });

    const chartData = Object.entries(monthlyCounts).map(([month, count]) => ({
        month,
        count
    })).sort((a, b) => a.month.localeCompare(b.month)); // optional: sort chronologically
    
    if (chartData.length === 0) {
        return <div className="text-gray-500">No orders to display.</div>;
    }
    return (
        <div style={{ width: '100%', height: '60vh' }}>
            <h3 className="text-xl font-semibold mb-4">Monthly Orders Overview</h3>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Bar dataKey="count" fill="#8884d8" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default MonthlyOrderChart;
